const ERROR_CONTENT_TYPES = ['application/json', 'text/html'];

const DEFAULT_STATUS_MESSAGES = {
    400: 'Invalid download request.',
    401: 'Your session has expired. Please sign in again.',
    404: 'File not found. The library may need to be synced.',
    502: 'SharePoint download failed. Please try again later.',
    503: 'SharePoint connection unavailable. Please contact support.',
};

export function resolveFileName(name, icon) {
    if (!name) {
        return 'download';
    }
    if (name.includes('.')) {
        return name;
    }
    const extensionByIcon = {
        pdf: '.pdf',
        word: '.docx',
        video: '.mp4',
    };
    return name + (extensionByIcon[icon] || '');
}

function isErrorLikeContentType(contentType) {
    if (!contentType) {
        return false;
    }
    return ERROR_CONTENT_TYPES.some((type) => contentType.includes(type));
}

async function readBlobText(blob) {
    if (!blob || typeof blob.text !== 'function') {
        return '';
    }
    return blob.text();
}

async function looksLikeJsonBlob(blob) {
    if (!blob || blob.size === 0) {
        return false;
    }
    const header = await blob.slice(0, 100).text();
    const trimmed = header.trimStart();
    return trimmed.startsWith('{') || trimmed.startsWith('[');
}

export async function readErrorFromBlob(blob, status) {
    let message = DEFAULT_STATUS_MESSAGES[status] || 'Unable to download file, try again later.';

    if (!blob) {
        return message;
    }

    try {
        const text = await readBlobText(blob);
        if (!text) {
            return message;
        }

        try {
            const parsed = JSON.parse(text);
            message = parsed.message || parsed.detail || parsed.error || message;
        } catch (_) {
            if (text.length <= 200) {
                message = text;
            }
        }
    } catch (_) {
        // keep default message
    }

    return message;
}

export async function validateLibraryDownloadResponse(response) {
    const contentType = (response.headers['content-type'] || '').toLowerCase();

    if (response.status >= 400) {
        throw new Error(await readErrorFromBlob(response.data, response.status));
    }

    if (isErrorLikeContentType(contentType) || await looksLikeJsonBlob(response.data)) {
        throw new Error(await readErrorFromBlob(response.data, response.status));
    }

    if (!response.data || response.data.size === 0) {
        throw new Error('Downloaded file is empty.');
    }

    return {
        blob: response.data,
        contentType: contentType || 'application/octet-stream',
    };
}
